import Page from "components/Page";
import { ExchangeRateListProps } from "./ExchangeRates.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ExchangeRates = lazyWithRetry(() => import("./ExchangeRatesList"));

export default (props: ExchangeRateListProps) => (
  <Page>
    <ExchangeRates {...props} />
  </Page>
);
